interface ClosingSectionProps {
  onOpenModal: () => void;
}

export default function ClosingSection({ onOpenModal }: ClosingSectionProps) {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-slate-900 via-orange-900 to-red-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-orange-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-500 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white space-y-12">
          {/* Emotional Statement */}
          <div className="space-y-8">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
              Se você continuar fazendo o que sempre fez,
              <span className="block text-red-400 mt-4">
                continuará tendo os mesmos resultados.
              </span>
            </h2>
            
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 lg:p-12 border border-white/20">
              <p className="text-xl lg:text-2xl leading-relaxed mb-6">
                Mas se decidir estruturar sua empresa como uma{' '}
                <span className="text-yellow-300 font-bold">máquina previsível de vendas</span>,
              </p>
              <p className="text-xl lg:text-2xl leading-relaxed">
                você para de <span className="text-red-400 font-bold">improvisar</span><br />
                e começa a <span className="text-green-400 font-bold">crescer com controle</span>.
              </p>
            </div>
            
            <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-8 lg:p-12">
              <p className="text-2xl lg:text-3xl font-bold mb-4">
                A decisão não é sobre marketing.
              </p>
              <p className="text-2xl lg:text-3xl font-bold text-yellow-300">
                É sobre maturidade empresarial.
              </p>
            </div>
          </div>
          
          {/* Final CTA */}
          <div className="space-y-6">
            <button 
              onClick={onOpenModal}
              className="bg-green-600 hover:bg-green-700 text-white px-12 py-6 rounded-lg font-bold text-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              AGENDAR REUNIÃO
            </button>
            
            <p className="text-gray-300 text-sm">
              <i className="ri-shield-check-line text-green-400 mr-2"></i>
              Diagnóstico 100% gratuito e sem compromisso
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
